import { useState } from "react";
import { ContentContainer, FormSubsection, MUITableD } from "components";
import { Modal } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Alerts from "./Alerts";

type Props = {
  data: any;
};

const MetadataResult = (props: Props) => {
  const { data } = props;
  const { t } = useTranslation("telemetry"); // Get translation
  const navigate = useNavigate();
  const [record, setRecord] = useState(null)

  const formatSec = (n: string): string => {
    var seconds = parseInt(n) || 0;
    var day = seconds / (24 * 3600);
    seconds = seconds % (24 * 3600);
    var hour = seconds / 3600;
    seconds %= 3600;
    var min = seconds / 60;
    seconds %= 60;
    var ret = "";
    if (day >= 1) {
      ret += day.toFixed(0) + "d "
    }
    if (hour >= 1) {
      ret += hour.toFixed(0) + "h "
    }
    if (min >= 1) {
      ret += min.toFixed(0) + "m "
    }
    if (seconds > 0) {
      ret += seconds + "s "
    }
    return ret;
  }

  const columns = [
    { name: "deviceId", label: t("Device ID") },
    { name: "lastSeenAt", label: t("Last Seen") },
    { name: "lastAuditEventAt", label: t("Last Audit") },
    { name: "lastFillEventAt", label: t("Last Fill Event") },
    { name: "lastErrorEventAt", label: t("Last Alert Event") },
    { name: "machineIdentification", label: t("VMC") },
    { name: "timeBetweenCalls", label: t("Audit period"), options: { customBodyRender: (value: string) => formatSec(value) }, },
    { name: "alerts", label: t("# of Alerts"), options: { customBodyRender: (value: Array<any>) => value.length }, }
  ];

  const handleRelRowClick = (rowdata: Array<String>, rowmeta: any) => {
    let record = data[rowmeta.dataIndex];
    console.log(record);
    setRecord(record);
  };

  const handleModalClose = () => {
    setRecord(null);
  }

  return (
    <>
      <ContentContainer py={4}>
        <FormSubsection title={t("Device Metadata")}>
          <MUITableD
            title=""
            data={data}
            cols={columns}
            sortOrder={{ name: "lastSeenAt", direction: "desc" }}
            onRowClick={handleRelRowClick}
          />
        </FormSubsection>
      </ContentContainer>

      <Modal open={!(record === null)} onClose={() => handleModalClose()}>
        <Alerts data={record} />
      </Modal>

    </>
  );
};

export default MetadataResult;
